import styled from '@emotion/styled';
import { withStyles } from '@material-ui/core/styles';
import MuiTextField from '@material-ui/core/TextField';

import COLORS from '$variables/colors';
import { spacing } from '$variables/theme';

export const SelectWrapper = styled.div`
  align-self: flex-start;
  align-items: center;
  display: flex;
  width: 100%;
  justify-content: space-between;

  & > :not(:first-of-type) {
    margin-left: ${spacing.xSmall};
  }
`;

export const SelectContainer = styled.div`
  flex-grow: 1;
  max-width: 360px;
`;

const customMuiTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: COLORS.green,
      },
      '& input': {
        fontSize: 14,
        lineHeight: spacing.xLarge,
      },
    },
  },
})(MuiTextField);

export const TextField = styled(customMuiTextField)`
  height: 38px;
  margin-top: 1px;
  margin-bottom: 0;
  width: 70px;
  min-width: 70px;
`;
